export const sidebarTranslations = {
  main: {
    assistant: { ru: "Ассистент", en: "Assistant" },
    revenueAiAutopilot: { ru: "Revenue AI Автопилот", en: "Revenue AI Autopilot" },
    marketIntelligence: { ru: "Аналитика рынка", en: "Market Intelligence" },
    miceCalculator: { ru: "MICE Калькулятор", en: "MICE Calculator" },
    aiAssistant: { ru: "AI Помощник", en: "AI Assistant" },
    analytics: { ru: "Аналитика", en: "Analytics" }
  },
  aiDirectors: {
    title: { ru: "AI Помощники", en: "AI Assistants" },
    strategicAdvisor: { ru: "Стратегический советник", en: "Strategic Advisor" },
    marketAnalyst: { ru: "Рыночный аналитик", en: "Market Analyst" },
    financialCenter: { ru: "Финансовый центр", en: "Financial Center" },
    marketingConsultant: { ru: "Маркетинговый консультант", en: "Marketing Consultant" },
    operationsOptimizer: { ru: "Операционный оптимизатор", en: "Operations Optimizer" },
    reputationCenter: { ru: "Центр репутации", en: "Reputation Center" },
    guestExperience: { ru: "Управление гостевым опытом", en: "Guest Experience Management" },
    fnbAnalyst: { ru: "F&B аналитик", en: "F&B Analyst" },
    hrStrategist: { ru: "HR стратег", en: "HR Strategist" },
    sustainabilityExpert: { ru: "Эксперт по устойчивому развитию", en: "Sustainability Expert" },
    securitySpecialist: { ru: "Специалист по безопасности", en: "Security Specialist" }
  },
  bookings: {
    title: { ru: "Бронирования", en: "Bookings" }
  },
  roomGrid: {
    title: { ru: "Шахматки", en: "Room Grids" },
    roomGrid: { ru: "Шахматка номеров", en: "Room Grid" },
    roomGridLite: { ru: "🚀 Room Grid Lite", en: "🚀 Room Grid Lite" },
    aiRoomGrid: { ru: "🧠 AI-Аналитик шахматки", en: "🧠 AI Room Grid Analyst" }
  },
  mainSections: {
    roomsAndRates: { ru: "Номера и тарифы", en: "Rooms and Rates" }
  },
  hotelSetup: {
    title: { ru: "Настройка отеля", en: "Hotel Setup" }
  },
  allSettings: {
    title: { ru: "Все настройки", en: "All Settings" },
    systemSettings: { ru: "Системные настройки", en: "System Settings" },
    universalConfigurator: { ru: "Универсальный конфигуратор", en: "Universal Configurator" },
    calendarAndRates: { ru: "Календарь и тарифы", en: "Calendar and Rates" },
    documentsSection: { ru: "152-ФЗ документы", en: "152-FZ Documents" },
    users: { ru: "Пользователи", en: "Users" },
    aiSpecialistsManagement: { ru: "Управление AI специалистами", en: "AI Specialists Management" },
    deletedBookings: { ru: "Удаленные бронирования", en: "Deleted Bookings" },
    dataMigration: { ru: "Миграция данных", en: "Data Migration" },
    specialOffers: { ru: "Спецпредложения", en: "Special Offers" },
    channelManager: { ru: "Channel Manager", en: "Channel Manager" },
    hotelWebsite: { ru: "Сайт отеля", en: "Hotel Website" },
    media: { ru: "Медиа", en: "Media" },
    hotelSwitcher: { ru: "Выбор отеля", en: "Hotel Switcher" }
  },
  footer: {
    logout: { ru: "Выход", en: "Logout" }
  }
};

export default sidebarTranslations;